import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {CreateWorkflowRequest, CreateWorkflowResponse} from './contracts'

export async function apiCreateWorkflow(body: CreateWorkflowRequest): Promise<CreateWorkflowResponse> {
  const apiData = getApiMetadata('memex-workflow-create-api-data')
  const {data} = await fetchJSON<CreateWorkflowRequest, CreateWorkflowResponse>(apiData.url, {
    method: 'POST',
    body,
    token: apiData.token,
  })

  return data
}
